import { BackendApiClient, isBackendConfigured } from '@/api/api-client';

export async function loginAztangofestParticipant(participantId: string) {
  if (!isBackendConfigured()) {
    throw new Error('Backend API is not configured (see src/config/appDefaults.ts).');
  }
  const id = participantId.trim();
  if (!id) throw new Error('Participant id is required');
  return BackendApiClient.AzdanceService.azdanceControllerLogin({
    body: { id },
  });
}
